<template>
  <div>
    <login-modal-component />
    <div class="p-6 md:p-0 md:pt-6">
      <div class="flex items-center justify-center md:justify-between mb-6">
        <img
          class="md:hidden block w-12"
          src="/img/logo-yuk-belajar.png"
          alt="Yuk Belajar">
        <h1 class="hidden md:block font-semibold text-xl text-blue-900">
          Olimpiade
        </h1>
      </div>
      <div class="flex flex-wrap items-stretch justify-between space-y-5 max-w-2xl mx-auto">
        <div
          v-for="exam in $store.state.exams"
          :key="exam.id"
          class="bg-gray-100 rounded-lg shadow-lg w-full">
          <h3 class="font-semibold text-center text-gray-600 text-xl mb-1 p-3 flex flex-col md:flex-row justify-center space-y-2 md:space-y-0 md:space-x-2">
            <span>{{ exam.title }}</span>
            <span class="hidden md:block"> - </span>
            <span>{{ exam.subtitle }}</span>
          </h3>
          <div class="space-y-5 pb-5">
            <product-component
              v-for="product in exam.products"
              :id="product.id"
              :key="product.id"
              class="mb-3"
              :name="product.name"
              :price="product.price"
              :full-price="product.full_price"
              :calculated-discount="product.calculated_discount"
              :description="product.description" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  mounted() {
    this.$nextTick(function () {
      this.$store.commit('setCurrentPath', 'products');
      this.$store.dispatch('loadExams');
    })
  },
  methods: {
  },
}
</script>
